import { IPlanner } from '../../interfaces/Planner/Planner'
import { configDateInitial } from '../../utils/dateHelper'
import { DataGridSettings } from '../../interfaces/DataGrid/DataGridSettings'

export const busquedaInitialState: Omit<
  IPlanner,
  | 'orderReferenceId'
  | 'orderOriginId'
  | 'workOrderTag'
  | 'origin'
  | 'includeWithoutTag'
  | 'ordersWithWorkOrder'
  | 'ordersWithCancellationRequest'
  | 'typeOrderId'
> = {
  id: 0,
  neighborhoodId: 0,
  courierId: 0,
  courierServiceId: 0,
  orderStateId: 0,
  initialDeliveryDate: configDateInitial(60),
  finalDeliveryDate: configDateInitial(-30),
  initialCreatedDate: configDateInitial(7),
  finalCreatedDate: configDateInitial(0),
  quantity: 0,
  numberUnitsInitial: 0,
  numberUnitsFinal: 0,
  byUnit: false,
  byMonoSKU: false,
  referenceId: '',
  typeWorkOrderId: 0,
  sku: '',
  workOrderId: 0,
  workOrderStateId: -1
}

export const dataGridSettings: DataGridSettings = {
  spacing: 0,
  sortingMode: 'single',
  columns: [
    {
      title: 'OT',
      dataField: 'workOrderId',
      xs: 12,
      sm: 6,
      lg: 3,
      allowSorting: false
    },
    {
      title: 'Fillrate',
      dataField: 'fillrate',
      xs: 12,
      sm: 6,
      lg: 3,
      allowSorting: false
    },
    {
      title: 'U. Totales',
      dataField: 'realQty',
      xs: 12,
      sm: 6,
      lg: 3,
      allowSorting: false
    },
    {
      title: 'Detalle',
      dataField: 'column-buttons',
      xs: 12,
      sm: 6,
      lg: 3,
      allowSorting: false
    }
  ]
}
